<template lang="pug">
  el-menu-item(
    index='/transactions'
    v-if="showItemDynamically(user, dynamicViewsConstants.resource_names.TRANSACTION, ['index'])"
  )
    .img-wrapper
      img(src="@src/assets/sidebar/transactions.svg")
    router-link.sub-menu-link(to="/transactions")
      span  {{ $t('sidebar.transactions') }}
</template>

<script>
import { general } from "@src/services/dynamicViews/general";
import { dynamicViewsConstants } from "@src/constants";
import { mapState } from "vuex";


export default {
  name: "TransactionsItem",
  mixins: [general],

  computed: {
    ...mapState("auth", ["user"]),
  },

  data() {
    return {
      dynamicViewsConstants
    }
  }
}
</script>
